import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './style.css';

const propTypes = {
  children: PropTypes.object,
  small: PropTypes.bool,
  loadingContainerStyle: PropTypes.object,
  btn: PropTypes.bool,
  loadingPositionStyle: PropTypes.object,
};

const defaultProps = {
  small: false,
  btn: false,
};

export default function Loading(props) {
  return (
    <div className={cx('loading__container', { 'loading__container--btn': props.btn })} style={props.loadingContainerStyle}>
      <div className={cx('loading', { 'loading--btn': props.btn, small: props.small })}>
        <ul style={props.loadingPositionStyle}>
          <li className={cx({ 'loading__cycle': true, 'loading__cycle--small': props.small })}></li>
          <li className={cx({ 'loading__cycle': true, 'loading__cycle--small': props.small })}></li>
          <li className={cx({ 'loading__cycle': true, 'loading__cycle--small': props.small })}></li>
        </ul>
      </div>
      {props.children}
    </div>
  );
}

Loading.propTypes = propTypes;
Loading.defualtTypes = defaultProps;



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/components/Loading/index.js
 **/